<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" >
      <b-col lg="10" xl="6">
        <b-card>
          <div slot="header">Laporan - Rekap Retur 
          </div>
              <b-input-group>
                  <b-input-group-prepend ><label >Jenis Rekap</label></b-input-group-prepend>
                  <b-form-radio-group  class="mt-2" v-model="model.jenisrekap" :state="!$v.model.jenisrekap.$error">
                      <b-form-radio value="salesae">Per Sales/AE</b-form-radio>
                      <b-form-radio value="group">Per group/Area</b-form-radio>
                  </b-form-radio-group>
              </b-input-group>
              <b-input-group>
                  <b-input-group-prepend ><label >Jenis Tanggal</label></b-input-group-prepend>
                  <b-form-radio-group  class="mt-2" v-model="model.jenistgl" :state="!$v.model.jenistgl.$error">
                      <b-form-radio value="1">Tgl. Proses</b-form-radio>
                      <b-form-radio value="2">Tgl.Edisi</b-form-radio>
                  </b-form-radio-group>
              </b-input-group>
            <b-input-group >
                  <b-input-group-prepend ><label >&nbsp;</label></b-input-group-prepend>
              <!-- <b-form-select v-model="model.jenistgl" :state="!$v.model.jenistgl.$error" :plain="true" class="mr-2" :options="pilihantgl"></b-form-select> -->
              <b-form-input v-model="model.tgl1" type="date" :state="!$v.model.tgl1.$error"></b-form-input>
              <b-input-group-prepend><span class="input-group-text">s.d</span></b-input-group-prepend>
              <b-form-input v-model="model.tgl2" type="date" :state="!$v.model.tgl1.$error"></b-form-input>
            </b-input-group >
            <b-row class="justify-content-center mt-1">
                <button class="btn btn-primary mr-1" @click="exportxls()">
                    <i class="fa fa-file-excel-o"></i>
                    Export
                </button>
              <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </b-row>
        </b-card>
        </b-col>
    </b-row>
      <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>

  </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import toastr from "mini-toastr";
import koranrptrekap from "../../apis/koran_report_rekap";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {Loading},
  mixins: [validationMixin],
  validations: {
        model: {
            jenisrekap: {required},
            jenistgl: { required },
            tgl1: { required },
            tgl2: { required }
        },
  }, 
  data() {
    return {
      showDelConfirm: false,
      showFrmCustomer:false,
      isLoading:false,
      model:{jenistgl:1, tgl1:'', tgl2:'', jenisrekap:'salesae'},
      pilihantgl:[{value:1, text: 'TGL. PROSES'}, {value:2, text: 'TGL. EDISI'}],
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  methods: {
    exportxls: async function() {
      if (this.invalidModel) {
          console.log('validation : ', this.$v.model);
          console.log('frmdata obj : ',this.model);
          toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      } else {
          try {
              this.isLoading=true;
              const data= {};
              data.tgl1 = moment(this.model.tgl1).format('YYYY-MM-DD');
              data.tgl2 = moment(this.model.tgl2).format('YYYY-MM-DD');
              data.jenistgl=this.model.jenistgl;
              let response = {};
              const link = document.createElement('a');
              if (this.model.jenisrekap=='salesae') {
                  response=await koranrptrekap.rekapreturae(data);
                  if (this.model.jenistgl==1) {
                        link.setAttribute('download', 'rekap_retur_per_AE.xlsx');
                  } else {
                        link.setAttribute('download', 'rekap_retur_per_AE_Edisi.xlsx');
                  }
              } else {
                response=await koranrptrekap.rekapreturgroup(data);
                if (this.model.jenistgl==1) {
                      link.setAttribute('download', 'rekap_retur_per_group.xlsx');
                } else {
                      link.setAttribute('download', 'rekap_retur_per_group_Edisi.xlsx');
                }
              }
              const url = window.URL.createObjectURL(new Blob([response.data]));
              link.href = url;
              document.body.appendChild(link);
              link.click();
              this.isLoading=false;    
          } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
          }
      }
    },   
    close(){
      router.push("home");
    },    
  }
};
</script>
